module.exports = __webpack_public_path__ + "img/check-mark-button-emoji.6aa12028.webp";